import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../services/auth";

const initialState = {
  signed: false,
  user: {},
  currentDB: ''
};

export const login = createAsyncThunk(
  "auth/login",
  async (loginInfo) => {
    const res = await authService.login(loginInfo);
    return res.data;
  }
);

export const getUser = createAsyncThunk(
  "auth/me",
  async () => {
    const token = localStorage.getItem("token");
    const res = await authService.getUser(token);
    return res.data;
  }
)

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state, action) => {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      state.signed = false;
    },
    changeDB: (state, action) => {
      state.currentDB = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state, action) => {
      const {access_token, type} = action.payload;    
      if(access_token) {
        state.signed = true;
        localStorage.setItem("token", access_token)
        localStorage.setItem("role", type)
      }
    })
    .addCase(getUser.fulfilled, (state, action) => {
      state.signed = true;
      state.user = action.payload;
      const role = localStorage.getItem("role");
      const {db} = action.payload;
      if(role === 'USER' && db && db.length > 0)
        state.currentDB = db[0].name;
    })
    .addCase(getUser.rejected, (state, action) => {
      state = initialState;
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      window.location.href = '/';
    })
  }
});
export const {
  logout,
  changeDB
} = authSlice.actions;
const { reducer } = authSlice;
export default reducer;